import React from 'react';

const MainLayout = ({ children, className = '' }) => {
  return (
    <div className={`gradient-pattern ${className}`}>
      <div>{children}</div>
    </div>
  );
};

export default MainLayout;